'use strict';
var twentyninetimes = twentyninetimes || {};

const svg1 = `
<svg width="54" height="42" viewBox="0 0 54 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.52428 13.6157C17.0604 5.01859 34.4801 0.346182 52.1434 0.0377837C52.9617 0.0234971 53.631 0.691246 53.631 1.50965L53.6304 30.3031C53.6304 31.1048 52.9871 31.7498 52.1857 31.7695C40.0495 32.0665 28.0835 35.2791 17.3521 41.1211C16.6483 41.5042 15.7694 41.2669 15.3688 40.573L0.970825 15.6348C0.561399 14.9256 0.807801 14.0122 1.52428 13.6157Z" fill="url(#paint0_linear_147_2001)"/>
<defs>
<linearGradient id="paint0_linear_147_2001" x1="42.4568" y1="35.8645" x2="10.4728" y2="0.788462" gradientUnits="userSpaceOnUse">
<stop stop-color="#F3D151"/>
<stop offset="1" stop-color="#F6DE83"/>
</linearGradient>
</defs>
</svg>
`;

const svg2 = `
<svg width="56" height="35" viewBox="0 0 56 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.82587 3.9048C19.0577 -0.37832 37.0931 -0.382984 54.2345 3.89074C55.0285 4.08873 55.5022 4.90695 55.2904 5.69746L47.8375 33.5097C47.63 34.284 46.8417 34.7406 46.0625 34.5521C34.263 31.698 21.8732 31.704 9.9954 34.5695C9.21652 34.7574 8.42893 34.3007 8.22156 33.5268L0.768706 5.71181C0.556774 4.92085 1.03119 4.10232 1.82587 3.9048Z" fill="url(#paint0_linear_147_1984)"/>
<path d="M1.82587 3.9048C19.0577 -0.37832 37.0931 -0.382984 54.2345 3.89074C55.0285 4.08873 55.5022 4.90695 55.2904 5.69746L47.8375 33.5097C47.63 34.284 46.8417 34.7406 46.0625 34.5521C34.263 31.698 21.8732 31.704 9.9954 34.5695C9.21652 34.7574 8.42893 34.3007 8.22156 33.5268L0.768706 5.71181C0.556774 4.92085 1.03119 4.10232 1.82587 3.9048Z" fill="url(#paint1_linear_147_1984)"/>
<defs>
<linearGradient id="paint0_linear_147_1984" x1="35.6052" y1="35.9896" x2="13.7894" y2="-6.16932" gradientUnits="userSpaceOnUse">
<stop stop-color="#F3D151"/>
<stop offset="1" stop-color="#F6DE83"/>
</linearGradient>
<linearGradient id="paint1_linear_147_1984" x1="54.5707" y1="16.4835" x2="-1.71898" y2="15.3456" gradientUnits="userSpaceOnUse">
<stop stop-color="#ECA640"/>
<stop offset="1" stop-color="#F1BC6F"/>
</linearGradient>
</defs>
</svg>
`;

const svg3 = `
<svg width="54" height="42" viewBox="0 0 54 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.78713 0.0168544C19.5404 0.339611 36.9624 5.00301 52.4136 13.5676C53.1294 13.9644 53.3751 14.8773 52.9659 15.5861L38.5686 40.5216C38.1678 41.2159 37.2882 41.4529 36.5843 41.0692C25.9256 35.2583 13.9564 32.0575 1.74166 31.7511C0.940695 31.7311 0.29814 31.0861 0.298144 30.2849L0.298293 1.48868C0.298298 0.669819 0.968403 0.00196873 1.78713 0.0168544Z" fill="url(#paint0_linear_147_1993)"/>
<path d="M1.78713 0.0168544C19.5404 0.339611 36.9624 5.00301 52.4136 13.5676C53.1294 13.9644 53.3751 14.8773 52.9659 15.5861L38.5686 40.5216C38.1678 41.2159 37.2882 41.4529 36.5843 41.0692C25.9256 35.2583 13.9564 32.0575 1.74166 31.7511C0.940695 31.7311 0.29814 31.0861 0.298144 30.2849L0.298293 1.48868C0.298298 0.669819 0.968403 0.00196873 1.78713 0.0168544Z" fill="url(#paint1_linear_147_1993)"/>
<path d="M1.78713 0.0168544C19.5404 0.339611 36.9624 5.00301 52.4136 13.5676C53.1294 13.9644 53.3751 14.8773 52.9659 15.5861L38.5686 40.5216C38.1678 41.2159 37.2882 41.4529 36.5843 41.0692C25.9256 35.2583 13.9564 32.0575 1.74166 31.7511C0.940695 31.7311 0.29814 31.0861 0.298144 30.2849L0.298293 1.48868C0.298298 0.669819 0.968403 0.00196873 1.78713 0.0168544Z" fill="url(#paint2_linear_147_1993)"/>
<defs>
<linearGradient id="paint0_linear_147_1993" x1="26.1113" y1="39.7512" x2="15.9504" y2="-6.6176" gradientUnits="userSpaceOnUse">
<stop stop-color="#F3D151"/>
<stop offset="1" stop-color="#F6DE83"/>
</linearGradient>
<linearGradient id="paint1_linear_147_1993" x1="49.4791" y1="25.8183" x2="-4.59803" y2="10.1503" gradientUnits="userSpaceOnUse">
<stop stop-color="#ECA640"/>
<stop offset="1" stop-color="#F1BC6F"/>
</linearGradient>
<linearGradient id="paint2_linear_147_1993" x1="25.9123" y1="34.4188" x2="22.7668" y2="-1.27671" gradientUnits="userSpaceOnUse">
<stop stop-color="#F0EB8A"/>
<stop offset="1" stop-color="#EDE9AB"/>
</linearGradient>
</defs>
</svg>
`;

twentyninetimes.reflectiontool = twentyninetimes.reflectiontool || function () {
    const toolStart = document.querySelector(".js-init-tool");
    let currentStep = 1;
    let selectedPath = null;
    let selectedAnswers = [];

    const restartButton = document.querySelector(".js-restart-tool");
    const printButton = document.querySelector(".js-print-page");

    // Color mapping for answers
    const answerColors = {
        'answer-1': '#EEB25A',
        'answer-4': '#EEB25A',
        'answer-7': '#EEB25A',
        'answer-2': '#F4D665',
        'answer-5': '#F4D665',
        'answer-8': '#F4D665',
        'answer-3': '#EEEA9D',
        'answer-6': '#EEEA9D',
        'answer-9': '#EEEA9D'
    };

    // Default color for skipped steps
    const defaultSkipColor = '#EDE9E6';

    function init() {
        const titles = document.querySelectorAll('.block-reflection__m-titles .m-title-1, .block-reflection__m-titles .m-title-2, .block-reflection__m-titles .m-title-3');
        titles.forEach((title) => {
            title.classList.remove('active');
        });

        if (toolStart) {
            initializeReflectionTool();
            selectablePaths();
            setupModalButtons();
            setupSkipButton();
            setupRestartButton();
            setupPrintButton();
            setupOutsideClickClose();
            adjustForeignObjectPositions();
        }
    }

    function initializeReflectionTool() {
        const toolStart = document.querySelector(".js-init-tool");
        const introModal = document.querySelector(".js-intro-message");
        const closeIntro = document.querySelector(".js-toggle-intro");
        const externalCircle = document.querySelector(".block-reflection__external");
        const containerOverflow = document.querySelector(".blocks-container");

        if (toolStart) {
            toolStart.addEventListener("click", (e) => {
                e.preventDefault();
                const tool = document.querySelector(".js-reflection-tool");
                const introStage = document.querySelector(".intro-stage");
                if (tool) {
                    introStage.classList.add("hidden");
                    tool.classList.toggle("active");
                    containerOverflow.classList.toggle("overflow-hidden");
                }

                setTimeout(() => {
                    if (introModal) {
                        introModal.classList.add("active");
                    }
                }, 1000);
            });

            if (closeIntro) {
                closeIntro.addEventListener('click', (e) => {
                    showRestartButton();
                    e.preventDefault();
                    if (introModal) {
                        introModal.classList.remove("active");
                    }
                    const tool = document.querySelector(".js-tool");
                    if (tool) {
                        setTimeout(() => {
                            tool.classList.add("stepOne");
                            externalCircle.classList.add("active");
                            showTitle(1);
                        }, 500);
                    }
                });
            }
        }
    }

    function showRestartButton() {
        if (restartButton) {
            restartButton.classList.add("active"); // Show the restart button
        }
    }

    function showPrintButton() {
        if (printButton) {
            printButton.classList.add("active"); // Show the print button
        }
    }

    function selectablePaths() {
        const paths = document.querySelectorAll('.selectable-path');
        const modal = document.querySelector('.js-answer-message');
        const modalSubheader = document.getElementById("js-answer-subheader");
        const modalTitle = document.getElementById("js-answer-header");
        const modalText = document.getElementById('js-answer-text');
        const modalSvg = document.getElementById('js-answer-svg');
        const modalExample = document.getElementById('js-answer-example');
        const closeModalButton = document.querySelector('.js-answer-close-modal');
        const selectAnswerButton = document.querySelector('.js-select-answer');
        const summaryReady = document.querySelector('.js-summary-ready');

        paths.forEach((path, index) => {
            path.addEventListener('click', function () {
                const pathId = this.id;

                if (pathsData[pathId]) {
                    modalSubheader.innerHTML = pathsData[pathId].rowTitle;
                    modalTitle.innerHTML = pathsData[pathId].title;
                    modalText.innerHTML = pathsData[pathId].text;
                    modalExample.innerHTML = pathsData[pathId].example;

                    // Insert the correct SVG based on the answer number
                    if (index < 3) {
                        modalSvg.innerHTML = svg1;
                    } else if (index < 6) {
                        modalSvg.innerHTML = svg2;
                    } else {
                        modalSvg.innerHTML = svg3;
                    }

                    // Show the modal as usual
                    modal.classList.add("active");

                    selectedPath = this;
                } else {
                    console.error(`No data found for path ID: ${pathId}`);
                }
            });
        });

        if (selectAnswerButton) {
            selectAnswerButton.addEventListener('click', function () {
                const tool = document.querySelector('.js-tool');

                if (selectedPath) {
                    const pathId = selectedPath.id;
                    const answerColor = answerColors[pathId]; // Get the color for the selected answer

                    if (pathsData[pathId]) {
                        selectedAnswers.push({
                            id: pathId,
                            title: pathsData[pathId].title,
                            text: pathsData[pathId].text,
                            example: pathsData[pathId].example,
                            color: answerColor, // Store the color with the answer
                            skipped: false  // Not skipped
                        });

                        selectedPath.classList.add('selected-path');
                    }
                    selectedPath = null;
                }

                // Close the modal before transitioning
                modal.classList.remove("active");

                if (tool) {
                    switch (currentStep) {
                        case 1:
                            tool.classList.remove("stepOne");
                            tool.classList.add("stepTwo");
                            currentStep++;
                            showTitle(currentStep);
                            break;
                        case 2:
                            tool.classList.remove("stepTwo");
                            tool.classList.add("stepThree");
                            currentStep++;
                            showTitle(currentStep);
                            break;
                        case 3:
                            // Delay the transition to ensure smooth closing of the modal
                            tool.classList.remove("stepThree");
                            tool.classList.add("toolComplete");
                            setTimeout(() => {
                                displaySummary(selectedAnswers);
                                showPrintButton();
                                if (summaryReady) {
                                    summaryReady.classList.add("active");
                                }
                            }, 1000); // Adjust the delay as necessary
                            break;
                    }
                }
            });

            closeModalButton.addEventListener('click', function () {
                modal.classList.remove("active");
            });
        }
    }

    function setupModalButtons() {
        const modal = document.querySelector('.js-question-message');
        const modalTitle = document.getElementById('js-question-title');
        const modalText = document.getElementById('js-question-text');
        const readMoreButtons = document.querySelectorAll('.block-reflection__readmore');

        readMoreButtons.forEach(button => {
            button.addEventListener('click', function (event) {
                // Open the modal on click
                const buttonId = this.id;

                if (questionData[buttonId]) {
                    const { title, text } = questionData[buttonId];
                    modalTitle.innerHTML = title;
                    modalText.innerHTML = text;
                    modal.classList.add("active");
                } else {
                    console.error(`No data found for button ID: ${buttonId}`);
                }
            });
        });

        const closeModalButton = document.querySelector('.js-close-modal');
        closeModalButton.addEventListener('click', function () {
            modal.classList.remove('active');
        });
    }

    function setupOutsideClickClose() {
        let modalClicked = false;
        const externalCircle = document.querySelector(".block-reflection__external");
        const doubtModal = document.querySelector('.js-doubt-message'); // Doubt modal reference

        document.addEventListener('mousedown', function (event) {
            const introModal = document.querySelector('.js-intro-message.active');
            const otherModals = document.querySelectorAll('.js-answer-message.active, .js-question-message.active, .js-doubt-message.active');

            modalClicked = false;

            // Check if click is inside any modal
            otherModals.forEach(modal => {
                if (modal.contains(event.target)) {
                    modalClicked = true;
                }
            });

            if (introModal && introModal.contains(event.target)) {
                modalClicked = true;
            }

            if (!modalClicked) {
                // Handle the intro message modal separately
                if (introModal && !introModal.contains(event.target)) {
                    introModal.classList.remove('active');

                    const tool = document.querySelector('.js-tool');
                    if (tool) {
                        if (!tool.classList.contains('active')) {
                            tool.classList.add('active');
                        }
                        if (!tool.classList.contains('stepOne')) {
                            setTimeout(() => {
                                tool.classList.add("stepOne");
                                externalCircle.classList.add("active");
                            }, 500);
                        }
                    }

                    showRestartButton(); // Show restart button when intro message is closed
                }

                // Handle clicks outside other active modals
                otherModals.forEach(modal => {
                    if (!modal.contains(event.target)) {
                        modal.classList.remove('active');
                    }
                });
            }
        });

        document.addEventListener('click', function (event) {
            // This prevents the document click event from immediately closing the modal
            if (modalClicked) {
                event.stopPropagation();
            }
        });
    }

    function setupSkipButton() {
        const skipButton = document.getElementById('js-answer-skip');
        const tool = document.querySelector('.js-tool');
        const modal = document.querySelector('.js-doubt-message');
        const confirmSkipButton = document.querySelector('.js-select-skip');
        const closeModalButton = document.querySelector('.js-skip-close-modal');

        function openModal() {
            modal.classList.add('active');
        }

        function closeModal() {
            modal.classList.remove('active');
        }

        function handleSkip() {

            // Add default skipped answer with color
            selectedAnswers.push({
                id: `step${currentStep}`,
                title: "I tvivl",
                text: "I tvivl",
                example: "",
                color: defaultSkipColor, // Set default color for skipped step
                skipped: true
            });

            if (tool) {
                switch (currentStep) {
                    case 1:
                        tool.classList.remove("stepOne");
                        tool.classList.add("stepTwo");
                        currentStep++;
                        showTitle(currentStep);
                        break;
                    case 2:
                        tool.classList.remove("stepTwo");
                        tool.classList.add("stepThree");
                        currentStep++;
                        showTitle(currentStep);
                        break;
                    case 3:
                        tool.classList.remove("stepThree");
                        tool.classList.add("toolComplete");
                        displaySummary(selectedAnswers);
                        const summaryReady = document.querySelector('.js-summary-ready');
                        showPrintButton();
                        summaryReady.classList.add("active");
                        break;
                    default:
                        console.error('Unknown step:', currentStep);
                        break;
                }
            }

            closeModal();
        }

        skipButton.addEventListener('click', openModal);

        confirmSkipButton.addEventListener('click', handleSkip);

        closeModalButton.addEventListener('click', closeModal);
    }

    function setupRestartButton() {
        const restartButton = document.querySelector('.js-restart-tool');

        restartButton.addEventListener('click', function () {
            // Reset all game variables
            currentStep = 1;
            selectedPath = null;
            selectedAnswers = [];

            // Reset the UI components
            const tool = document.querySelector('.js-tool');
            if (tool) {
                tool.classList.remove("stepTwo", "stepThree", "toolComplete");
                tool.classList.add("stepOne");
            }

            const paths = document.querySelectorAll('.selectable-path');
            paths.forEach(path => {
                path.classList.remove('selected-path');
            });

            const tables = document.querySelectorAll('.block-reflection__table');
            tables.forEach(table => {
                table.querySelector('.js-table-header').innerHTML = "";
                table.querySelector('.js-table-text').innerHTML = "";
                table.querySelector('.js-table-example').innerHTML = "";
                table.querySelector('.js-table-example-text').innerHTML = "";
                table.classList.remove('skipped');
            });

            // Hide the summary section if it's active
            const summaryReady = document.querySelector('.js-summary-ready');
            if (summaryReady) {
                summaryReady.classList.remove("active");
            }

            // Reset titles
            const titles = document.querySelectorAll('.block-reflection__m-titles .m-title-1, .block-reflection__m-titles .m-title-2, .block-reflection__m-titles .m-title-3');
            titles.forEach((title) => {
                title.classList.remove('active');
            });

            // Show the first title
            showTitle(1);
        });
    }

    function displaySummary(answers) {
        const tables = document.querySelectorAll('.block-reflection__table');
        tables.forEach((table, index) => {
            if (answers[index]) {
                const header = table.querySelector('.js-table-header');
                const text = table.querySelector('.js-table-text');
                const example = table.querySelector('.js-table-example');
                const exampleText = table.querySelector('.js-table-example-text');
                const svgPath = table.querySelector('svg path'); // Select the SVG path
                const tableContent = table.querySelector('.block-reflection__tablecontent');

                header.innerHTML = answers[index].title;

                if (answers[index].skipped) {
                    text.innerHTML = "";
                    example.innerHTML = "";
                    exampleText.innerHTML = "";
                    table.classList.add('skipped');

                    // Apply default background color for skipped content
                    if (tableContent) {
                        tableContent.style.background = defaultSkipColor;
                    }

                    // Apply default color to the SVG icon for skipped steps
                    if (svgPath) {
                        svgPath.style.fill = defaultSkipColor;
                    }
                } else {
                    text.innerHTML = answers[index].text;
                    example.innerHTML = "Eksempel";
                    exampleText.innerHTML = answers[index].example;

                    // Update the SVG color and table content background
                    if (svgPath) {
                        svgPath.style.fill = answers[index].color; // Apply the color to the SVG path
                    }
                    if (tableContent) {
                        tableContent.style.background = answers[index].color; // Apply the answer color to the content background
                    }
                }
            }
        });

        const summarySection = document.querySelector('.block-reflection__summary');
        if (summarySection) {
            summarySection.scrollIntoView({ behavior: 'smooth' });
        }
    }

    function setupPrintButton() {
        const printButton = document.querySelector(".js-print-page");

        if (printButton) {
            printButton.addEventListener("click", function () {
                window.print();  // Trigger the print dialog
            });
        }
    }

    function adjustForeignObjectPositions() {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const foreignObjects = document.querySelectorAll('foreignObject');

        foreignObjects.forEach((fo) => {
            const currentX = parseFloat(fo.getAttribute('x'));
            const currentY = parseFloat(fo.getAttribute('y'));

            if (isSafari) {
                // Safari-specific adjustments
                if (currentX === 38 && currentY === 148) {
                    fo.setAttribute('x', '55'); // Safari x value for the first foreignObject
                    fo.setAttribute('y', '108'); // Safari y value for the first foreignObject
                    fo.querySelector('.block-reflection__rowtitle').classList.add('title-one');
                } else if (currentX === 836.008 && currentY === 96) {
                    fo.setAttribute('x', '832'); // Safari x value for the second foreignObject
                    fo.setAttribute('y', '120'); // Safari y value for the second foreignObject
                    fo.querySelector('.block-reflection__rowtitle').classList.add('title-three');
                }
            } else {
                // Chrome-specific adjustments
                if (currentX === 38 && currentY === 148) {
                    fo.setAttribute('x', '38'); // Chrome x value for the first foreignObject
                    fo.setAttribute('y', '148'); // Chrome y value for the first foreignObject
                } else if (currentX === 832 && currentY === 120) {
                    fo.setAttribute('x', '836.008'); // Chrome x value for the second foreignObject
                    fo.setAttribute('y', '96'); // Chrome y value for the second foreignObject
                }
            }
        });
    }

    function showTitle(stepNumber) {
        // Remove 'active' class from all titles
        const titles = document.querySelectorAll('.block-reflection__m-titles .m-title-1, .block-reflection__m-titles .m-title-2, .block-reflection__m-titles .m-title-3');
        titles.forEach((title) => {
            title.classList.remove('active');
        });

        // Add 'active' class to the current step's title
        const activeTitle = document.querySelector(`.block-reflection__m-titles .m-title-${stepNumber}`);
        if (activeTitle) {
            activeTitle.classList.add('active');
        }
    }

    return {
        init: init
    };
}();